/*
 * Copyright (c) 2024 Ask Sage, Inc. All rights reserved.
 * This software is the confidential and proprietary information of Ask Sage, Inc.
 * You shall not disclose such confidential information and shall use it only in
 * accordance with the terms of the license agreement you entered into with Ask Sage, Inc.
 * THIS SOFTWARE IS PROVIDED "AS IS" AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 * INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL ASK SAGE, INC.
 * OR ITS CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT
 * OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
 * STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 * You may not use this software except in compliance with the License.
 * You may not modify, reverse engineer, or redistribute this software.
 */
import React, { useState, useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import { Container, Row, Col } from 'reactstrap';
import * as default_data from '../config.js'
import { getToken } from '../AuthService.js';
import { getWithExpiry, setWithExpiry } from '../AuthService.js';
import { getBannerColor } from '../Utils/classification_helper.js';

function SAMLLogin() {
  const [searchParams] = useSearchParams();
  const [loaded, setLoaded] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  var loaded_static = false;

  function loadLogin() {
    var token = getToken()
    if(token === false) {
      return;
    }

    const app_state = searchParams.get("app_state");
    const code = searchParams.get("code");

    if(app_state === null || code === null) {
      setIsLoading(false);
      setErrorMessage('Internal error, please reach out to our customer support.');          
      return;
    }

    setIsLoading(true);
    setErrorMessage('');          

    var orig_app_state = getWithExpiry('saml_app_state');
    var orig_code_verifier = getWithExpiry('saml_code_verifier');
    var orig_url =getWithExpiry('saml_orig_url');

    fetch(default_data.default_user_service_url_no_cac + '/login-saml', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-access-tokens': `${token}`
      },
      body: JSON.stringify({
        'app_state': app_state,
        'orig_app_state': orig_app_state,
        'orig_code_verifier': orig_code_verifier,
        'orig_url': orig_url,
        'code': code
      })
    })
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('An error occurred while getting data.');
      })
      .then(data => {
        if(data.status != 200) {
          setIsLoading(false);
          setErrorMessage('Internal error, please reach out to our customer support.');          
        }
        else {
          data = data.response;
          setIsLoading(false);
          setErrorMessage('');
          console.log(data);
          
          // Save the access token and user data to local storage and redirect to the dashboard
          setWithExpiry('access_token', data.access_token);
          setWithExpiry('user', JSON.stringify(data.user));
  
          window.location = '/dashboard';  
        }
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
        setErrorMessage('Internal error, please reach out to our customer support.');          
      });
  }

  useEffect(() => {
    if(loaded || loaded_static) {
      return;
    }

    setLoaded(true)
    loaded_static = true;

    loadLogin()

    }, [])


  return (
    <div>
    { 
      <div className={`header-message ${getBannerColor(false)}`}>
        { default_data.default_banner_override != null && default_data.default_banner_override != '' ?
            default_data.default_banner_override : 'UNCLASSIFIED' 
        }
      </div>            
    }
    <div className="reg-page-mode">
    <Container>
      <Row className="justify-content-center reg-page-mode-header">
        <Col xs="12" md="12" lg="12">
            <div>
              <h2 style={{margin: '30px 20px', textAlign: 'center'}}>Redirecting you to your SSO provider, please wait...</h2>
            </div>
            {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
          </Col>
      </Row>
      <Row className="justify-content-center reg-page-mode-footer">
        <Col xs="12" md="12" lg="12">
          Copyright &copy; {default_data.default_copywrite_year} Ask Sage, Inc.
        </Col>
      </Row>
      </Container>  
      </div>    
    </div>
  );
}

export default SAMLLogin;